module.exports = __webpack_public_path__ + "assets/images/2d95f345999e69eb4c533b3326ced22e.png";